module.exports = __webpack_public_path__ + "img/20220415_100939.ce5d5481.jpg";